import { Collection, Select, TextInput, NumberInput, MultilineInput, Checkbox } from "@tblabs/truffle";
import { DateSlider } from "../../../../Components/Utils/DateSlider";
import { PersonalPickupStep } from "../../../../Steps/PersonalPickup/PersonalPickupStep";
import { Step } from "../../../../Steps/Step/Step";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { BasketItemsSelector } from "./BasketItemsSelector";
import { Entry } from "./Entry";


export class PersonalPickupEntryEditBox extends Entry<Step<any>>
{
    constructor(step: PersonalPickupStep, steps: Collection<Step<any>>)
    {
        super(step, steps, []);
        this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));

        this.AddField("Przedmioty", new BasketItemsSelector(step.Order.BasketItems, step.Data.ItemsIds));
        this.AddInput("Stan", new Select(step.Data.State, step.AllStates));
        this.AddField("Planowany czas spotkania", new DateSlider(step.Data.PlannedDispatchTime));
        this.AddField("Realny czas spotkania", new DateSlider(step.Data.DispatchTime));
        this.AddInput("Miejsce spotkania", new TextInput(step.Data.MeetingPlace));
        this.AddInput("Pobrana gotówka", new NumberInput(step.Data.BasketSum));
        this.AddInput("Depozyt", new NumberInput(step.Data.DepositSum));
        this.AddInput("Trening", new Checkbox(step.Data.Training));
        this.AddInput("Informacje o kliencie", new MultilineInput(step.Data.CustomerInfo).Rows(5));
        this.AddInput("Informacje o spotkaniu", new MultilineInput(step.Data.MeetupNotes).Rows(5));
    }
}
